import DemoNavbar from "components/Navbars/DemoNavbar";
import Sidebar from "components/Sidebar/Sidebar";
import { routes } from "../../routes/routes";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import imagenTabernas from "../../assets/avantSolar//HuertasClientes/clientes_tabernas.jpg";
import imagenAlbox from "../../assets/avantSolar//HuertasClientes/clientes_albox.jpg";
import imagenIniesta from "../../assets/avantSolar//HuertasClientes/clientes_iniesta2.jpg";
import imagenVjara from "../../assets/avantSolar//HuertasClientes/clientes_vjara2.jpg";
import imagenVmesia from "../../assets/avantSolar//HuertasClientes/clientes_vmesia3.jpg";
import BarchartInfoCliente from "components/chart/BarChartInfoCliente";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import DataTableAvantSolar from "components/datatable/datatable";
import Footer from "components/Footer/Footer";
import PerfectScrollbar from "perfect-scrollbar";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import { Helmet } from "react-helmet-async";

var ps;

function InformacionCliente(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [datosInfo, setDatosInfo] = useState({});
  const [datosTabla, setDatosTabla] = useState([]);
  const [datosTablaCopy, setDatosTablaCopy] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const { jwt, user } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [aniosOption, setAniosOption] = useState([]);

  useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current, {
      suppressScrollX: true, // Disable horizontal scrollbar
    });
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  }, []);

  useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  useEffect(() => {
    let anio = parseInt(new Date().getFullYear());
    let anios = [];

    for (let index = anio; index >= 2007; index--) {
      anios.push({ value: index, label: index });
    }

    setAniosOption(anios);
  }, []);

  const fetchInformacionCliente = async (anio = 2023) => {
    setLoading(true);
    let userName;
    if (params.username == "user") {
      userName = user.email;
    } else {
      userName = params.username;
    }
    try {
      const response = await avantSolarApi.get(
        `/all/clientInfo?id_huerta=${huerta}&username=${userName}&anio=${anio}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      setLoading(false);
      if (data?.code == 200) {
        setDatosTabla(data.data.lecturas);
        setDatosTablaCopy(data.data.lecturas);
        setDatosInfo(data.data.ultimaLectura);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response);
    }
  };

  useEffect(() => {
    fetchInformacionCliente();
  }, []);

  //Al cambiar el valor del select, se vuelve a hacer la petición con el año seleccionado
  const fetchInformacionCienteAnio = (event) => {
    fetchInformacionCliente(event.value);
  };

  const headers = [
    [
      "Fecha",
      "Energía Generada",
      "Energía Consumida",
      "Neta (KWh)",
      `Periodo desde lectura anterior`,
      "Periodo ( KWH ) Export-Import=Neta",
    ],
  ];

  const headersTable = [
    { name: "Fecha", prop: "fecha" },
    { name: "Energía Generada", prop: "energiaGenerada" },
    { name: "Energía Consumida", prop: "energiaConsumida" },
    { name: "Neta (KWh)", prop: "neta" },
    { name: "Periodo desde lectura anterior", prop: "periodoLecturaAnterior" },
    { name: "Periodo ( KWH ) Export-Import=Neta", prop: "periodo" },
  ];

  const properties = [
    "fecha",
    "energiaGenerada",
    "energiaConsumida",
    "neta",
    "periodoLecturaAnterior",
    "periodo",
  ];

  return (
    <>
      <Helmet>
        <title>Información del cliente</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div style={{ height: "99vh" }} className="wrapper">
        <Sidebar {...props} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <div>
            <DemoNavbar {...props} />
            {!error && (
              <Row>
                <Col
                  xs={12}
                  sm={6}
                  md={5}
                  xl={4}
                  className=" p-0 pb-4 fondoColumna"
                >
                  <div className="linea1">
                    <Row>
                      <Col xs={1}>
                        <div className="linea2 h-100 p-3"></div>
                      </Col>
                      <Col>
                        <div className="d-flex justify-content-center flex-column align-items-center p-2">
                          <p className="p-0 m-0 h4 font-weight-bold">
                            ÁREA CLIENTES
                          </p>
                          <p className="p-0 m-0 text-light h6">
                            {datosInfo?.titular} -{" "}
                            {obtenerNombreHuertaId(
                              parseInt(datosInfo?.id_huerta)
                            )}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col xs={12}>
                      <div className="d-flex justify-content-center">
                        <div className=" p-4 bg-white rounded mt-3 w-75">
                          <p>ÚLTIMA LECTURA CONTADOR:</p>
                          <div className="border border-secondary p-3 m-2 mb-3">
                            <p className="d-flex justify-content-between ">
                              {datosInfo?.fechaIni}

                              <span>
                                <span className="font-weight-bold">
                                  {datosInfo?.lecturaIni}
                                </span>{" "}
                                KWh
                              </span>
                            </p>
                          </div>
                          <p>Energía generada último periodo:</p>
                          <div className="border border-secondary p-3 m-2">
                            {datosInfo?.fechaIni && (
                              <p className="d-flex d-flex justify-content-between ">
                                Lectura {datosInfo?.fechaIni}:
                                <span>
                                  <span className="font-weight-bold">
                                    {datosInfo?.lecturaIni}{" "}
                                  </span>
                                  KWh
                                </span>
                              </p>
                            )}

                            {datosInfo?.fechaAnt && (
                              <p className="d-flex d-flex justify-content-between ">
                                Lectura {datosInfo?.fechaAnt}:
                                <span>
                                  <span className="font-weight-bold">
                                    {datosInfo?.lecturaAnt}{" "}
                                  </span>
                                  KWh
                                </span>
                              </p>
                            )}
                            <p className="text-center mt-2">
                              Generados{" "}
                              <span className="font-weight-bold">
                                {datosInfo?.generados}{" "}
                              </span>
                              KWh en
                              <span className="font-weight-bold">
                                {" "}
                                {datosInfo?.periodoLecturaAnterior}{" "}
                              </span>
                            </p>
                            <p className="text-center">
                              Energía media diaria:{" "}
                              <span className="font-weight-bold">
                                {datosInfo?.eMedia}
                              </span>{" "}
                              KWh:
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="w-100 mt-5  d-none d-sm-block">
                    <img
                      draggable="false"
                      width={"100%"}
                      src={obtenerNombreHuertaId(parseInt(datosInfo.id_huerta))}
                    ></img>
                  </Row>
                </Col>
                <Col xs={12} sm={6} md={7} xl={8} className="  pt-4">
                  {datosTabla && (
                    <>
                      <div className="mx-4">
                        <BarchartInfoCliente
                          data2={datosTabla}
                          menuLateral={true}
                        />

                        <div className="d-flex justify-content-end">
                          {aniosOption.length > 0 && (
                            <Select
                              onChange={(event) =>
                                fetchInformacionCienteAnio(event)
                              }
                              defaultValue={aniosOption[0]}
                              menuPlacement="top"
                              name="anio"
                              options={aniosOption}
                              className="basic-multi-select w-50 mt-3 mb-3"
                              classNamePrefix="select"
                            />
                          )}
                        </div>
                      </div>

                      <div>
                        <DataTableAvantSolar
                          data={datosTabla}
                          dataCopy={datosTablaCopy}
                          setData={setDatosTabla}
                          titleProps={"Información Cliente"}
                          headers={headers}
                          headersTable={headersTable}
                          name={"informaciónCliente"}
                          properties={properties}
                          defaultMostrar={"Todos"}
                          loading={loading}
                          inputSearch={false}
                        ></DataTableAvantSolar>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            )}
            {error && <Alert message={error} />}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default InformacionCliente;
